/**
 * Manage the how data are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const StorageService = {
    getItem(key, jsonParse = false, base64Decode = false) {
        let item = localStorage.getItem(key);

        if (item === 'undefined' || item === null) {
            return false;
        }

        if (base64Decode) {
            item = atob(item);
        }

        if (jsonParse) {
            item = JSON.parse(item);
        }

        return item;
    },

    saveItem(key, value, base64Encode = false) {
        if (typeof value === "object") {
            value = JSON.stringify(value);
        }

        if (base64Encode) {
            value = btoa(value);
        }

        localStorage.setItem(key, value);
    },

    removeItem(key) {
        localStorage.removeItem(key)
    }
}

export default StorageService
